import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ChevronRightIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="m15.759 11.35.558.65-.558.65-6 7-1.518-1.3L13.684 12 8.24 5.65l1.518-1.3z" />
  </BaseIcon>
)
